module.exports = __webpack_public_path__ + "df2fce031a73e216701f98fba9ca072c.svg";